import { ErrorInfo } from "react"
import cn from "classnames"

import { Analytics } from "utils/analytics"
import { Text } from "ui-kit/components-branded/index"
import { useDidMount } from "utils/customHooks"
import { IS_STAGING } from "utils/env-management"

export interface CustomErrorInfo extends ErrorInfo {
    [key: string]: unknown
}
export interface ErrorPageProps {
    error?: Error
    errorInfo?: CustomErrorInfo
}

export function ErrorPage({ error, errorInfo }: ErrorPageProps) {
    useDidMount(() => {
        Analytics.error()
    })
    return (
        <div className={cn("search-results", { app: !IS_STAGING })}>
            <div className="error">
                <h4>Что-то пошло не так. </h4>
                <h6>Мы в ближайшее время посмотрим, что случилось.</h6>
                <h6>Сейчас попробуйте перезагрузить страницу.</h6>
                {IS_STAGING && (
                    <Text>
                        {error && (
                            <>
                                <pre>{error.message}</pre>
                                <br />
                            </>
                        )}
                        <pre>{errorInfo?.componentStack}</pre>
                    </Text>
                )}
            </div>
        </div>
    )
}
